import { type UseQueryResult, useQuery } from 'react-query';
import { ParticipantAnnualIncomeService } from '../../services/wealthlane-customer-services';

const useGetParticipantAnnualIncome = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string;
    }>
  | undefined,
  unknown
> => {
  const ParticipantAnnualIncomeList = useQuery(
    ['getParticipantAnnualIncomeList'],
    async () => {
      return await handleRequest(
        ParticipantAnnualIncomeService.getApiCustomerApiAppParticipantAnnualIncomeParticipantAnnualIncomesList()
      );
    },
    {
      select: (data) => {
        return data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
      },
    }
  );

  return ParticipantAnnualIncomeList;
};

export default useGetParticipantAnnualIncome;
